// extracted by mini-css-extract-plugin
export var nav = "navigation-module--nav--3afkS";
export var nav_item = "navigation-module--nav_item--Nqxse";
export var link = "navigation-module--link--6Wcwi";